import { versionCheck } from '../../../helpers';
import { isUnpaid } from '../../permissions';
import { RestrictionsApplier } from '../restrictionsApplier';

export class BasicRestrictionsApplier extends RestrictionsApplier {
    applicable(billing, lenient) {
        return billing.plan === 'basic' || isUnpaid(billing, lenient);
    }

    apply({ card: { links, reviews, design, products, profile, messengers }, projectVersion = '1.0.0' }) {
        let applied = false;
        // let count = 0;

        // for (const link of links) {
        //     if (link.enabled) {
        //         if (count > 0) {
        //             applied = true;
        //             link.enabled = false;
        //         }
        //
        //         count++;
        //     }
        // }

        // if (products.enabled) {
        //     products.enabled = false;
        //     applied = true;
        // }

        // if (reviews.enabled) {
        //     reviews.enabled = false;
        //     applied = true;
        // }

        if (versionCheck(projectVersion, '>=2.11')) {
            let count = 0;

            for (const messenger of messengers) {
                if (messenger.enabled) {
                    if (count > 0) {
                        applied = true;
                        messenger.enabled = false;
                    }
                    count++;
                }
            }
        }

        if (profile.website.enabled) {
            profile.website.enabled = false;
            applied = true;
        }

        if (!design.branding) {
            design.branding = true;
            applied = true;
        }

        if (products.collectionsEnabled) {
            products.collectionsEnabled = false;
            applied = true;
        }

        if (design.background.type !== 'color') {
            design.background.type = 'color';
            applied = true;
        }

        return applied;
    }
}
